import React from 'react'
import {Route, Switch} from 'react-router-dom';
import Started from './started/Started';


function HomeRoute() {
	return (
		<Switch>
			<Route exact component={Started} />
		</Switch>
	)
}

HomeRoute.propTypes = {
}

HomeRoute.defaultProps = {
}

export default HomeRoute;